import zIndex from "@material-ui/core/styles/zIndex";

const styles = theme => ({
  footer: {
    height: '35px',
    justifyContent: 'flex-end',
    display: 'flex',
    position: 'fixed',
    width: '100%',
    bottom: 0,
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    paddingRight: 30,
    fontSize: '14px',
    '& p': {
      color: theme.palette.primary.contrastText,
    },
    zIndex: 99,
  },
  link: {
    textDecoration: 'none',
    paddingLeft: 24,
    paddingRight: 24,
  }
});

export default styles;
